import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTcsmEpiProps, setMyCPGMidyearSettings } from '../../../../../global/ducks/epi-api';
import { TcsmEpiApiState, TcsmStates } from '../../../../../root/tcsm-model';


export function useMyCPGMidYearSettings(mycpgMidYearSettingId: string) {
	const dispatch = useDispatch();
	const epiApiState = useSelector<TcsmStates, TcsmEpiApiState>(state => state.epiProps);
	const language = useSelector<TcsmStates, string>(state => state.globalization.currentlanguage);
	const guid = useSelector<TcsmStates, string>(state => state.authenticatedState?.clientGuid);
	useEffect(() => {
		if (!epiApiState?.myCpgMidyearSettingsState?.contentLoaded) {
			dispatch(getTcsmEpiProps(dispatch, mycpgMidYearSettingId, { guid }, language, false, setMyCPGMidyearSettings));
		}

	}, []);

	return epiApiState?.myCpgMidyearSettingsState?.contentLoaded;
}